import { render, staticRenderFns } from "./PointDetails.vue?vue&type=template&id=67de4fd6&scoped=true&"
import script from "./PointDetails.vue?vue&type=script&lang=js&"
export * from "./PointDetails.vue?vue&type=script&lang=js&"
import style0 from "./PointDetails.vue?vue&type=style&index=0&id=67de4fd6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67de4fd6",
  null
  
)

export default component.exports